import { Dialog, DialogContent, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AuthFeature, AuthMode } from './AuthFeature';

interface AuthDialogProps {
  open: boolean;
  onClose: () => void;
  onAuthenticated?: () => Promise<void> | void;
  subtitle?: string;
  allowedModes?: AuthMode[];
  initialMode?: AuthMode;
}

const DialogContentStack = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2.5),
  paddingTop: theme.spacing(1),
}));

export function AuthDialog({
  open,
  onClose,
  onAuthenticated,
  subtitle,
  allowedModes,
  initialMode,
}: AuthDialogProps) {
  const handleAuthenticated = async () => {
    onClose();
    await onAuthenticated?.();
  };

  // Always allow recovery and register unless explicitly restricted
  const effectiveAllowedModes: AuthMode[] =
    allowedModes && allowedModes.length > 0
      ? allowedModes
      : ['login', 'recovery', 'register'];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        <DialogContentStack>
          <AuthFeature
            onCancel={onClose}
            onAuthenticated={handleAuthenticated}
            subtitle={subtitle}
            allowedModes={effectiveAllowedModes}
            initialMode={initialMode}
          />
        </DialogContentStack>
      </DialogContent>
    </Dialog>
  );
}
